import { useTranslation } from 'react-i18next'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'

const ConfirmBoxDetectBanWord = ({
  isActive,
  onClose,
}: {
  isActive: boolean
  onClose: any
}) => {
  const { t } = useTranslation()

  return (
    <ConfirmBoxBasic
      isActive={isActive}
      title={t('confirm_box_detect_ban_word.title')}
      content={
        <span
          dangerouslySetInnerHTML={{
            __html: t('confirm_box_detect_ban_word.content'),
          }}
        />
      }
      onClose={onClose}
      onOk={onClose}
    />
  )
}

export default ConfirmBoxDetectBanWord
